export default __webpack_public_path__ + "static/media/09.2a9e8ce4.jpg";